import React from 'react'
import './Footer.css'

const Footer = () => {
    return (
        <div className="footer">
            <h5>Store Details</h5>
            <h5>Target</h5>
            <p>Cham Towers, Plot 12 NKruma Rd, Kampala, Ug</p>
        </div>
    )
}

export default Footer
